import React, { useEffect, useState } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    styled,
    Card,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    Chip,
    OutlinedInput,
    MenuItem,
    Checkbox,
    ListItemText
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../common/CommonRestricted';

import { initialValues, validationSchema } from "../../../schema/groups/administratorSchema";

import { useUsers, userTypes, targetTypes as userTargetTypes } from "../../../hooks/api/useUsers";
import { useGroups, groupTypes, targetTypes, scopeTypes } from "../../../hooks/api/useGroups";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes as permissionScopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from "../../../hooks/useTranslations";

import { spliceString } from "../../../utils/formatString";

import { useAppContextFeatures } from "../../../context/AppContext";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


export default function NewAdministrator({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@group"] })

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures()
    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const { isLoading, create } = useGroups({ groupType: groupTypes.administrator, targetType: targetTypes.administrator })
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.group.id, permissionScopeTypes.group.administrator.id)

    const { list } = useUsers({ userType: userTypes.admin })

    const [dataUsers, setDataUsers] = useState([])

    const fetchUsers = async () => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    // {
                    //     name: "rack_id",
                    //     operator: filterOperatorTypes.eq,
                    //     value: id
                    // }
                ]
            };

            const { data } = await list(props)
            const { administrators } = data;

            setDataUsers(administrators)

        } catch (error) {
            // promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const onSubmit = async (currentValues) => {

        try {

            const ownerData = currentValues.userId.map((i) => {
                return {
                    user_id: i,
                    type: "administrator"
                }
            })

            let data = {
                group: {
                    label: currentValues?.name,
                    description: currentValues?.description,
                    status: currentValues?.status ? 1 : 0,
                },
                props: {
                    action_type: currentValues?.actionType
                },
                owners: ownerData

            }

            const response = await create({ data, scopeType: "", targetType: targetTypes.administrator });

            promptMessage(true, `${response?.message}`)
            navigate(getRoute("groups/administrators"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;

    useEffect(() => {

        fetchUsers()

    }, [])

    const getUserOptionNameByUserId = (optionIdArray) => {

        if (!optionIdArray) return []

        // dataUsers.filter(i => i.id === parentId)

        let optionNames = [];

        dataUsers.forEach((e) => {
            // e.options.forEach((e2) => {
            // if(e2.option_key === optionIdArray){
            if (optionIdArray.includes(e.user_id)) {
                optionNames.push(`${e.firstname} ${e.lastname} (${e.username})`)
            }
            // })
        })

        return optionNames
    }


    const RenderForm = () => {

        if (!values) return <></>

        return (

            <form onSubmit={handleSubmit}>
                <StyledCard>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t('information')}
                                subTitle={t('profileDataDetails')}
                            />

                        </Grid>
                        <Grid item xs={12} sm={12} md={8}>

                            <Grid container spacing={1}>

                                <Grid item xs={12} md={6} textAlign="left">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="status"
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.status) ? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <></>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"name"}
                                        label={t("name")}
                                        type="text"
                                        variant="outlined"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={touched.name && errors.name}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"description"}
                                        label={t("description")}
                                        type="text"
                                        rows={3}
                                        multiline
                                        variant="outlined"
                                        value={values.description}
                                        onChange={handleChange}
                                        error={touched.description && Boolean(errors.description)}
                                        helperText={touched.description && errors.description}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ mt: 1, mb: 1 }} />
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t('scopes')}
                                subTitle={t('groupingDataRange')}
                            />

                        </Grid>
                        <Grid item xs={12} sm={12} md={8}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={7}>
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.actionType && Boolean(errors.actionType)}
                                    >
                                        <InputLabel id="actionType">{t('type')}</InputLabel>

                                        <Select
                                            labelId="actionType"
                                            label={t('type')}
                                            name={"actionType"}
                                            onChange={handleChange}
                                            value={values.actionType}
                                        >
                                            {
                                                scopeTypes.administrator.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.id}
                                                        >
                                                            <ListItemText
                                                                primary={`${i.name}`}
                                                            />
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <FormHelperText>
                                            {touched.actionType && errors.actionType}
                                        </FormHelperText>

                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={12} xs={12}>


                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.userId && Boolean(errors.userId)}
                                    >
                                        <InputLabel id="userId">{t('administrators')}</InputLabel>

                                        <Select
                                            labelId="userId"
                                            label={t('administrators')}
                                            name={"userId"}
                                            onChange={(event) => {
                                                setFieldValue("userId", event.target.value)
                                            }}
                                            value={values.userId.length ? values.userId : []}
                                            renderValue={(selected) => {

                                                return (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                        {
                                                            getUserOptionNameByUserId(selected).map((i, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    label={spliceString({ val: i, maxLength: 50 })}
                                                                />
                                                            ))
                                                        }
                                                    </Box>
                                                )

                                            }}
                                            multiple
                                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                        >
                                            {
                                                dataUsers?.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.user_id}
                                                        >
                                                            <Checkbox checked={values.userId.indexOf(i?.user_id) > -1} />
                                                            <ListItemText
                                                                primary={`${i.firstname} ${i.lastname} (${i.username})`}
                                                            />
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <FormHelperText>
                                            {touched.userId && errors.userId}
                                        </FormHelperText>

                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>

        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newAdministratorGroup })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("groupNewAdministrator")}
                breadcrumbs={[
                    {
                        displayText: t("groupAdministrators"),
                        props: {
                            href: getRoute(`groups/administrators`)
                        }
                    },
                    {
                        displayText: t("groupNewAdministrator"),
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}